import { IPage, IPageRange } from '@aon/aon-tws-common-ui';
import axios from 'axios';
import Constants from '../constants';
import { IAudience } from '../models';

function noCacheHeader() {
	return { Pragma: 'no-cache' };
}

export function getAudiencesQuery(surveyId: number) {
	const url = Constants.AUDIENCES_API_BASE_URL.replace('{surveyId}', surveyId.toString());
	return url;
}

export const defaultAudiencePageRange: IPageRange = { offset: 0, limit: 5000 };

export function getAudiencesPagedQuery(surveyId: number, pageRange: IPageRange) {
	// We are currently doing client side paging, so bring back all audiences instead of using pageRange.
	return Constants.AUDIENCES_API_BASE_PAGED_URL.replace('{surveyId}', surveyId.toString())
		.replace('{offset}', defaultAudiencePageRange.offset.toString())
		.replace('{limit}', defaultAudiencePageRange.limit.toString())
		.replace('{searchText}', '');
}

export function getAudienceQuery(surveyId: number, audienceId: number, force?: boolean) {
	let url = Constants.AUDIENCE_API_BASE_URL.replace('{surveyId}', surveyId.toString()).replace('{audienceId}', audienceId.toString());

	if (force !== undefined) {
		url += `?force=${force === true ? 'true' : 'false'}`;
	}

	return url;
}

export function getDeleteDistributionOptionDataQuery(surveyId: number, audienceId: number) {
	return getAudienceQuery(surveyId, audienceId) + '/distribution-options';
}

export async function getPagedAudiences(surveyId: number, pageRange: IPageRange): Promise<IPage<IAudience>> {
	const res = await axios.get(getAudiencesPagedQuery(surveyId, pageRange), { headers: noCacheHeader() });
	return res.data;
}

export async function addAudience(audience: IAudience): Promise<IAudience> {
	const res = await axios.post(getAudiencesQuery(audience.surveyId), audience, { headers: noCacheHeader() });
	return res.data;
}

export async function updateAudience(audience: IAudience, publishAudience?: boolean): Promise<IAudience> {
	const publish: boolean = publishAudience ?? false;
	let url = getAudienceQuery(audience.surveyId, audience.audienceId);
	url += `?publishAudience=${publish === true ? 'true' : 'false'}`;
	const res = await axios.put(url, audience, { headers: noCacheHeader() });
	return res.data;
}

export async function copyAudience(audienceId: number, isTestAudience: boolean, surveyId: number): Promise<IAudience> {
	const url = Constants.AUDIENCE_COPY_API_BASE_URL.replace('{surveyId}', surveyId.toString())
		.replace('{audienceId}', audienceId.toString())
		.replace('{isTestAudience}', isTestAudience.toString());
	const res = await axios.post(url, { headers: noCacheHeader() });
	return res.data;
}

export async function deleteAudience(audience: IAudience, force: boolean): Promise<IAudience> {
	const res = await axios.delete(getAudienceQuery(audience.surveyId, audience.audienceId, force), { headers: noCacheHeader() });
	return res.data;
}

export async function deleteDistributionOptionData(audience: IAudience): Promise<any> {
	const res = await axios.delete(getDeleteDistributionOptionDataQuery(audience.surveyId, audience.audienceId), {
		headers: noCacheHeader(),
	});
	return res.data;
}

export async function getAudience(surveyId: number, audienceId: number): Promise<IAudience> {
	const res = await axios.get(getAudienceQuery(surveyId, audienceId), { headers: noCacheHeader() });
	return res.data;
}

export async function deletePersonAttributesOfAudience(surveyId: number, audienceId: number): Promise<any> {
	const res = await axios.delete(
		Constants.SURVEY_BUILDER_SURVEYS_API_URL + '/' + surveyId + '/audiences/' + audienceId + '/personattributes',
	);
	return res.data;
}
